import { Component, OnInit, AfterViewInit, ApplicationRef, OnDestroy } from '@angular/core';
import { MediaManagerService, OnMedia} from "../wb/services/media/media-manager.service";
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { DomSanitizer } from '@angular/platform-browser';
import { HbManagerService } from '../wb/services/hb/hb-manager.service';
import { HbParserService } from '../wb/services/hb/hb-parser.service';
import { MediaParserService } from '../wb/services/media/media-parser.service';
import { WsService2, OnWSConnection } from '../wb/services/ws/ws.service';

import { LogService } from '../wb/services/log/log.service';
declare var window;

declare var $;
declare var adapter;
declare var SoundMeter;
//declare var webrtcDetectedBrowser;
//declare var webrtcDetectedVersion;
//declare var AdapterJS;
//declare var ActiveXObject;
declare var navigator: any;
@Component({
  selector: "dskl-tech-check",
  templateUrl: "tech-check.component.html",
  providers: [LogService, HbParserService, HbManagerService, MediaManagerService, MediaParserService, WsService2]
})
export class TechCheckComponent implements AfterViewInit, OnWSConnection, OnMedia, OnDestroy {
  constructor(private mediaParser:MediaParserService, private ws: WsService2, private hbManager: HbManagerService, private translate: TranslateService, private sanitizer: DomSanitizer, private appRef: ApplicationRef, private mediaManager: MediaManagerService, public route: ActivatedRoute, public router: Router) {
  
  
  }
  
  webrtcDetectedBrowser
  webrtcDetectedVersion
youtubeSafari
	onMediaReconnected(){}
	onIncomingUpdated(who, connected){}
	onMediaUpdated(who, media){
    this.onMediaConnected(media);
  }
onMediaConnected(media){
    console.log("Got connected");
    this.clearConnectivityHandler()
    this.checkConnectivityCompleted = true;
    this.checkConnectivitySuccess = true;
    this.canGetIn = true;
    this.closeConnectivity();
    this.dynamic++;
}
closeConnectivity(){
    this.ws.cleanResources();
    this.ws.close(true);
}
  ngAfterViewInit() {
    try{
      this.browserVersion();
    }catch(error){
      console.log(error);
    }
    console.log("Will check the browser")
    this.check();
    this.ws.changeTitles();
  }
  onMediaError(error){
    this.checkConnectivityCompleted = true;
    this.checkConnectivitySuccess = false;
    this.closeConnectivity();
    if (error)
      this.showError(this, error, true);
  }
  clearConnectivityHandler(){
    if (this.connectivityHandler){
      try{
        clearInterval(this.connectivityHandler);
      }catch(error){}
    }
  }
  onConnected(){
    console.log("Connected to ws, can continue");
    this.mediaManager.registerOnMediaCallback(this);
    this.mediaParser.testConnectivity("audio");
    this.clearConnectivityHandler()
    var self = this;
    this.connectivityHandler = setTimeout(function(){
      self.onMediaError(null);
    }, 10000);
   
  }
  connectivityHandler 
  onDisconnected(){

  }
  userHash
  sub;
  browserVersion(){
    console.log(navigator.userAgent)
      var ua= navigator.userAgent, tem, 
      M= ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
      if(/trident/i.test(M[1])){
          tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
          return 'IE '+(tem[1] || '');
      }
      if(M[1]=== 'Chrome'){
          tem= ua.match(/\b(OPR|Edge)\/(\d+)/);
          if(tem!= null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
      }
      M= M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
      if((tem= ua.match(/version\/(\d+)/i))!= null) M.splice(1, 1, tem[1]);
      
      this.webrtcDetectedBrowser = M[0];
      this.webrtcDetectedVersion = M[1];
       
      if (!this.webrtcDetectedBrowser){
        
        this.webrtcDetectedBrowser = adapter.browserDetails.browser;
        if (this.webrtcDetectedBrowser == "edge" || this.webrtcDetectedBrowser == "Edge"){
          this.webrtcDetectedVersion = adapter.browserDetails.version;
        }
      }else{
        this.webrtcDetectedBrowser = this.webrtcDetectedBrowser.toLowerCase();
      }

  
  
  }
  ngOnInit() {
    /*AdapterJS.options.hidePluginInstallPrompt = true;
    navigator.getUserMedia = (navigator.getUserMedia ||
      navigator.webkitGetUserMedia ||
      navigator.mozGetUserMedia ||
      navigator.msGetUserMedia);
*/
    var self = this;
    this.sub = this.route.params.subscribe(params => {


      if (params['hash']) {
        self.userHash = params['hash']
      }
      self.ws.setHash(self.userHash);
    });


  }
  ngOnDestroy() {
    this.closeConnectivity();
    this.sub.unsubscribe();

  }
  getIn() {
    console.log("Getting in")
    window.location.href = "#/wb/" + this.userHash;
    
  }
  resetChecks() {
    try{
      this.closeConnectivity();
    }catch(error){

    }
    var self = this;
    this.checkConnectivityCompleted = false;
    this.checkConnectivitySuccess = false;
    self.checkAudioFailedNoDevice = false;
    self.checkVideoFailedNoDevice = false;
    self.checkVideoCompleted = false;
    self.checkVideoSuccess = false;
    self.checkVideoFailedPermission = false;
    self.checkAudioFailedConstraintNotSatisfied = false;
    self.checkVideoFailedConstraintNotSatisfied = false;

		self.isSafari = false;
    self.browserCheckSuccess = false;
    self.oldBrowser = false;
    self.withPlugin = false;
    self.pluginFound = false;
    self.ready = false;
    self.browserChecked = false;
    self.cantHearYou = false;
    self.checkAudioSuccess = false
    self.checkAudioCompleted = false;
    self.checkAudioFailedPermission = false;
    self.dynamic = 0;
    self.checkVideoFailedLockedByAnotherProgram = false;
    self.checkAudioFailedLockedByAnotherProgram = false;
  }
  checkAudioSuccess = false
  checkAudioCompleted = false;
  checkAudioFailedPermission = false;
  cantHearYou = false;
  oldBrowser = false;
  browserUnsuported = false;
  withPlugin = false;
  pluginFound = false;
  ready = false;
  browserChecked = false;
  checkAudioFailedNoDevice = false;
  checkVideoFailedNoDevice = false;
  checkVideoCompleted = false;
  checkVideoSuccess = false;
  checkVideoFailedPermission = false;
  checkAudioFailedConstraintNotSatisfied = false;
  checkVideoFailedConstraintNotSatisfied = false;
  checkVideoFailedLockedByAnotherProgram = false;
  checkAudioFailedLockedByAnotherProgram = false;
  checkConnectivityCompleted = false;
  checkConnectivitySuccess = false;
  browserCheckSuccess = false;
  safariPlugin = false;
  iePlugin = false;
  canGetIn = false;
	isSafari = false;
  check() {
    var self = this;
    self.resetChecks();

    this.checkBrowser(function () {
      console.log('getting user media')
			//if (!self.isSafari) {
	      self._getUserMedia(true, function () {
	        console.log('getting user media')

	       // self._getUserMedia(false, function () {
            //done
            self.ws.registerOnWSConnection(self);
            self.hbManager.onReady(true, true);
	          
	          
	        })
	      //});
			//}
    });

  }
  max = 4;
  dynamic = 0;
  browser() {
   
    return this.webrtcDetectedBrowser + " (в." + this.webrtcDetectedVersion+")."
  }
  browserName(){
    let str:string = this.webrtcDetectedBrowser;
    str = str[0].toUpperCase() + str.slice(1);
    return str
  }
  browserVersionTxt(){
    return this.webrtcDetectedVersion;
  }
  // checkInternetConnection(cb) {
  //   let self = this;
  //   let c = function () {
  //     console.log('checking bandwith');
  //     cb()
  //     self.dynamic++;
  //   }

  //   let xhr = new XMLHttpRequest();
  //   let url = '?cache=' + Math.floor(Math.random() * 10000); // prevent cache
  //   let data = getRandomString(1); // 1mb data
  //   let startTime;
  //   let speed = 0;

  //   xhr.onreadystatechange = function( event ) {
  //     if(xhr.readyState == 4) {
  //       let now = new Date()
  //       speed = Math.round( 1024 / (( now.getTime() - startTime) / 1000));
  //       console.log(speed)
  //     }
  //   }

  //   xhr.open( 'POST' , url, true);
  //   startTime = new Date().getTime();
  //   xhr.send(data)

  //   function getRandomString( sizeInMb ) {
  //       var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789~!@#$%^&*()_+`-=[]\{}|;':,./<>?", //random data prevents gzip effect
  //           iterations = sizeInMb * 1024 * 1024, //get byte count
  //           result = '';
  //       for( var index = 0; index < iterations; index++ ) {
  //           result += chars.charAt( Math.floor( Math.random() * chars.length ) );
  //       };
  //       return result;
  //   };
  // }
newSafari(){
  return this.webrtcDetectedVersion >=11;
}
  checkBrowser(cb) {
    var self = this;
    var c = function () {
      console.log('calling callback')
      cb();
      self.dynamic++;
    }
    console.log("Current browser is " + this.webrtcDetectedBrowser + " " + this.webrtcDetectedVersion)
    let versions = {  "chrome":80};//, "opera": 22, "firefox": 30, "safari": 11, "edge": 15.15063 };
    for (var k in versions) {
      var v = versions[k]
      if (k === this.webrtcDetectedBrowser) {
        if (this.webrtcDetectedVersion < v) {
          this.oldBrowser = true;
          this.browserChecked = true;
          this.browserCheckSuccess = false;
        } else {
            this.browserChecked = true;
            this.browserCheckSuccess = true;
            c();
        }
      }
    }
    if (!this.browserChecked){
      this.browserChecked = true;
      this.browserUnsuported= true;
      this.browserCheckSuccess = false;
    }
  }
  
  showError(self, error, audio){
    if (audio){
    self.checkAudioCompleted = true;
    self.checkAudioSuccess = false;
    }else{
      self.checkVideoCompleted = true;
      self.checkVideoSuccess = false;
    }
    if (error && error.name) {
      self.canGetIn = false;
      console.log("Got error ", error);
      switch (error.name) {

        case "SecurityError":
        case "PermissionDismissedError":
        case "PermissionDeniedError":
        case "NotAllowedError":
          if (audio)
            self.checkAudioFailedPermission = true;
          else
            self.checkVideoFailedPermission = true;
        if (this.webrtcDetectedBrowser=='safari' && this.webrtcDetectedVersion>=11){
          self.check = function(){window.location.reload()};
        }
          break;
        case "NotFoundError":
        case "DevicesNotFoundError":
        case "NotReadableError":
          if (audio)
            self.checkAudioFailedNoDevice = true;
          else
            self.checkVideoFailedNoDevice = true;
          break;
        case "ConstraintNotSatisfiedError":
          if (audio)
            self.checkAudioFailedConstraintNotSatisfied = true;
          else
            self.checkVideoFailedConstraintNotSatisfied = true;
          break;
        case "SourceUnavailableError":
          if (audio) {
            self.checkAudioFailedLockedByAnotherProgram = true;
          } else {
            self.checkVideoFailedLockedByAnotherProgram = true;
          }
          break;
      }
      self.appRef.tick();
    }
    self.appRef.tick();
  }
  audioH
  checkMicIfWorking(stream, cb) {
    
    if (this.webrtcDetectedBrowser=='safari') {
      this.checkAudioCompleted = true;
      this.checkAudioSuccess = true;
      this.dynamic++;
      cb()
      return
    }

    var self = this;
    window.AudioContext = window.AudioContext || window.webkitAudioContext;

    if (window.audioContext == null)
      window.audioContext = new AudioContext();
    var soundMeter = new SoundMeter(window.audioContext);
    
    soundMeter.connectToSource(stream, function (e) {
      if (e) {
        alert(e);
        return;
      }
      if (self.audioH)
        clearInterval(self.audioH)
      self.audioH = setInterval(function () {
        var level = soundMeter.instant.toFixed(2);
        if (level > 0.0) {
          clearInterval(self.audioH);
          self.checkAudioCompleted = true;
          self.checkAudioSuccess = true;
          self.cantHearYou = false;
          self.appRef.tick();
          self.mediaManager.stopOutgoingStream(stream);
          soundMeter.stop();
          if (cb) {
            self.dynamic++;
            cb();
          }
        } else {
          self.checkAudioCompleted = true;
          self.checkAudioSuccess = false;
          self.cantHearYou = true;
          self.appRef.tick();
        }
        console.log("Mic volume: " + level);
      }, 200);
    });
  } _getUserMedia(audio, cb) {
    console.log('getting user media')
    var self = this;
    
    this.mediaManager.getLocalVideoAudio(!audio, audio, function(stream){
      if (audio){
        self.checkMicIfWorking(stream, cb);
      }else{
        self.mediaManager.stopOutgoingStream(stream);
          self.checkVideoCompleted = true;
          self.checkVideoSuccess = true;
          self.dynamic++;

          cb();
          self.appRef.tick();
      }
      //
    }, function(error){
      self.showError(self, error, audio);
    });
    /*try {
      
      
      var constraints = { audio: audio, video: !audio };
      navigator.getUserMedia(constraints, function (stream) {
        if (audio) {
          self.checkMicIfWorking(stream, cb);

        } else {
          self.mediaManager.stopOutgoingStream(stream);
          self.checkVideoCompleted = true;
          self.checkVideoSuccess = true;
          self.dynamic++;

          cb();
          self.appRef.tick();
          return;
        }
        self.appRef.tick();

      }, function (error) {

        if (audio) {
          self.checkAudioCompleted = true;
          self.checkAudioSuccess = false;
        } else {
          self.checkVideoCompleted = true;
          self.checkVideoSuccess = false;
        }
        debugger;
        if (error && error.name) {
          self.canGetIn = false;
          console.log("Got error ", error);
          switch (error.name) {

            case "SecurityError":
            case "PermissionDismissedError":
            case "PermissionDeniedError":
            case "NotAllowedError":
              if (audio)
                self.checkAudioFailedPermission = true;
              else
                self.checkVideoFailedPermission = true;
            if (this.webrtcDetectedBrowser=='safari' && this.webrtcDetectedVersion>=11){
              self.check = function(){window.location.reload()};
            }
              break;
            case "NotFoundError":
            case "DevicesNotFoundError":
            case "NotReadableError":
              if (audio)
                self.checkAudioFailedNoDevice = true;
              else
                self.checkVideoFailedNoDevice = true;
              break;
            case "ConstraintNotSatisfiedError":
              if (audio)
                self.checkAudioFailedConstraintNotSatisfied = true;
              else
                self.checkVideoFailedConstraintNotSatisfied = true;
              break;
            case "SourceUnavailableError":
              if (audio) {
                self.checkAudioFailedLockedByAnotherProgram = true;
              } else {
                self.checkVideoFailedLockedByAnotherProgram = true;
              }
              break;
          }
          self.appRef.tick();
        }
        self.appRef.tick();
      });

    } catch (error) {
console.error(error);
    }*/
  }
  browserType() {
    
    return this.webrtcDetectedBrowser;
  }

  userMediaError(error) {
    var self = this;
    console.log("Got error ", error);

    if (error && error.name) {
      switch (error.name) {
        case "PermissionDismissedError":
        case "PermissionDeniedError":
          console.log("Failing")





          this.checkAudioFailedPermission = true


          break;

        /*
        case "ConstraintNotSatisfiedError":
          Checks.log("device "+device, "ConstraintNotSatisfiedError")

          if (device =='audio'){
            result.html(Checks._failHTML).removeClass("pass fail").addClass("fail");
            status.text("<spring:message code="tech_no_mic2"/>");
          }else{
            result.html(Checks._failHTML).removeClass("pass fail").addClass("fail");
            status.text("<spring:message code="tech_no_cam2"/>");
          }
          //Checks._browserResult("Looks like you don't have "+device);

          //console.log("You dont have "+device);
          break;
        default:
          Checks.log("device "+device, "Error "+options.error.name)

          break;
      }
    */
        //		}
        //	break;
      }
    }
  }

}



// WEBPACK FOOTER //
// /app/src/app/tech-check/tech-check.component.ts